import { Injectable } from '@angular/core';
import { DataSourceUtils } from '../../shared/utils/data-source-utils';
import { of } from 'rxjs';

@Injectable()
export class IvrTableDataSource extends DataSourceUtils<any> {
  update() {}

  onConnect() {
    return of([[{ position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' }], 1]);
  }
}
